import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";



const LineupRequirements = (props) => {
    
        

    return (
        
                                

                                <Accordion.Item eventKey="3">
                                   <Accordion.Header>Lineup Requirements</Accordion.Header>
                                    <Accordion.Body>
                                     <p>QB - 1, WR - 3, RB - 2, FLEX - 1, K - 1, TE - 1, DST - 1</p>
                                    
                                    </Accordion.Body>
                                </Accordion.Item>
                                
                              
                           

    )
}

export default LineupRequirements

